var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "0 6.4 48 35.22",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.597 6.4h41.403v28.55l-6.7 6.67h-41.3v-28.644z",
    fill: "#41cd52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.714 13.8c1.572-1.04 3.516-1.303 5.364-1.286 1.76.022 3.607.33 5.066 1.38 1.06.745 1.75 1.895 2.208 3.085.743 1.953.96 4.062.986 6.138.003 2.1-.1 4.226-.783 6.218a6.96 6.96 0 0 1 -2.51 3.393l2.53 4.06-3.155 1.457-2.7-4.44c-1.217.2-2.46.184-3.684.05-1.465-.176-2.958-.622-4.088-1.608-.87-.752-1.414-1.805-1.787-2.875-.6-1.8-.775-3.736-.803-5.635-.015-2.053.116-4.138.736-6.108.48-1.482 1.272-2.96 2.6-3.83zm17.846-.066h3.304l.002 4.37 4.223.001-.077 2.836c-1.407.003-2.812-.001-4.22.002l.005 7.163c.027.654.012 1.343.3 1.947.2.465.775.585 1.235.6l2.602-.07.154 2.607c-1.726.3-3.537.637-5.25.095-.722-.214-1.395-.693-1.688-1.407-.525-1.215-.567-2.566-.6-3.87v-7.065c-.768-.002-1.536.001-2.303-.002v-2.835l2.302-.002.002-4.37z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.676 15.5c1.07-.14 2.19-.102 3.203.302a3.49 3.49 0 0 1 1.884 1.763c.564 1.22.78 2.564.89 3.893.118 1.768.102 3.553-.142 5.31-.17 1.046-.416 2.15-1.124 2.974-.72.828-1.828 1.183-2.89 1.266-1.122.082-2.305 0-3.318-.53a3.224 3.224 0 0 1 -1.386-1.413c-.355-.724-.55-1.515-.688-2.306-.414-2.5-.513-5.108.052-7.603.233-.94.57-1.908 1.26-2.617.598-.608 1.432-.922 2.263-1.04z",
    fill: "#41cd52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQt);
export default __webpack_public_path__ + "static/media/qt.3448df0eb7a0903fa858a7012afd7ca2.svg";
export { ForwardRef as ReactComponent };